
import React from "react";
import Navigation from "@/components/Navigation";
import { motion } from "framer-motion";

const MassageTypes = () => {
  const massageTypes = [
    {
      title: "Tajski Masaż Klasyczny",
      description: "Zanurz się w tysiącletniej tradycji tajskiego masażu klasycznego, unikalnej terapii, która łączy głęboką akupresurę z technikami pasywnego rozciągania, przynoszącymi ciału korzyści zbliżone do jogi, bez Twojego wysiłku. Wykonywany bez olejków, na macie i w luźnym stroju, ten głęboki zabieg harmonijnie stymuluje przepływ energii w ciele. Poczuj, jak Twoje ciało odzyskuje elastyczność, napięcia mięśniowe znikają, a zablokowane kanały energetyczne otwierają się, przynosząc falę odnowionej energii i wewnętrznej harmonii. To idealny wybór dla tych, którzy pragną głębokiej regeneracji, poprawy mobilności i odczuwalnego przypływu sił witalnych, prowadzącego do lepszego samopoczucia na co dzień.",
      images: ["/photos/tajski.webp", "/photos/tajski1.webp"]
    },
    {
      title: "Masaż pleców, głowy i ramion",
      description: "Skoncentrowana ulga dla Twoich pleców, karku i głowy, czyli obszarów szczególnie narażonych na skutki współczesnego trybu życia. Ten masaż to idealne rozwiązanie dla osób spędzających wiele godzin przy biurku, zmagających się z chronicznym stresem lub odczuwających uciążliwe napięciowe bóle głowy. Doświadczona terapeutka precyzyjnie rozluźni nawet głęboko spięte mięśnie, stymulując krążenie i przynosząc natychmiastowy komfort oraz uczucie lekkości. Pozwól sobie na chwilę wytchnienia, która nie tylko przyniesie ulgę w bólu i sztywności, ale także pomoże odzyskać jasność umysłu, poprawić koncentrację i zredukować nagromadzony stres.",
      images: ["/photos/glowy.webp"]
    },
    {
      title: "Masaż Relaksacyjny",
      description: "Poczuj błogie odprężenie i zanurz się w świecie głębokiego relaksu dzięki naszemu wyjątkowemu masażowi relaksacyjnemu. Delikatne, płynne ruchy, wykonywane z troską i precyzją, w połączeniu z ciepłem starannie dobranych, aromatycznych olejków, ukoją Twoje zmysły i rozluźnią każdy mięsień Twojego ciała, od stóp do głów. To doskonały sposób na ucieczkę od codziennego stresu, wyciszenie pędzącego umysłu i przywrócenie bezcennej wewnętrznej równowagi, tak potrzebnej w dzisiejszym świecie. Zanurz się w atmosferze spokoju, pozwól by troski odpłynęły, a Twoja skóra została odżywiona, pozostawiając Cię z uczuciem głębokiego relaksu, odnowy i długotrwałego dobrego samopoczucia.",
      images: ["/photos/relax.webp", "/photos/relax1.webp"]
    }
  ];

  return (
    <div className="bg-dark min-h-screen text-gold-light">
      <Navigation />
      
      <div className="pt-32 pb-16">
        <div className="container mx-auto px-4">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-center text-gold mb-16"
          >
            Rodzaje Masaży
          </motion.h1>

          <div className="space-y-24">
            {massageTypes.map((massage, index) => (
              <motion.div
                key={massage.title}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
                className="bg-dark-light rounded-lg p-8 shadow-lg"
              >
                <h2 className="text-3xl font-semibold text-gold mb-6 text-center">
                  {massage.title}
                </h2>
                
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div className="space-y-4">
                    <p className="text-lg leading-relaxed text-justify">
                      {massage.description}
                    </p>
                    <button
                      onClick={() => window.open("https://booksy.com/pl-pl/139856_chaba-thai-massage_masaz_20103_slupsk#ba_s=sh_1", "_blank")}
                      className="bg-gold text-dark px-6 py-3 rounded-full hover:bg-gold-dark transition-colors"
                    >
                      Umów się na masaż
                    </button>
                  </div>
                  
                  <div className="flex flex-col gap-4">
                    {massage.images.map((image, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={image}
                        alt={massage.title}
                        className="w-full h-64 object-cover rounded-lg shadow-md"
                        width="600"
                        height="400"
                      />
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MassageTypes;
